import React from 'react';
import { Col } from 'antd';
import { useTranslation } from 'react-i18next';

export function ReportStatus(props) {
  const reportState = props.name;
  const { t } = useTranslation('report');

  let descriptionKey;
  if (reportState === 'Under Review') {
    descriptionKey = 'statusDescriptions.underReview';
  } else if (reportState === 'Verified') {
    descriptionKey = 'statusDescriptions.verified';
  } else if (reportState === 'Verified Scam') {
    descriptionKey = 'statusDescriptions.scam';
  } else if (reportState === 'Verified Genuine') {
    descriptionKey = 'statusDescriptions.genuine';
  } else if (reportState === 'Disruption In Progress') {
    descriptionKey = 'statusDescriptions.disruptionInProgress';
  } else if (reportState === 'Submitted') {
    descriptionKey = 'statusDescriptions.submitted';
  } else if (reportState === 'Closed') {
    descriptionKey = 'statusDescriptions.closed';
  } else if (reportState === 'Notify Brand') {
    descriptionKey = 'statusDescriptions.brand';
  } else if (reportState === 'Scam Disrupted') {
    descriptionKey = 'statusDescriptions.disrupted';
  } else {
    descriptionKey = 'statusDescriptions.notFound';
  }
  return <Col span={24}>{t(descriptionKey)}</Col>;
}
